import { render, staticRenderFns } from "./OrderPaginatedTable.vue?vue&type=template&id=4c5831d3&scoped=true&"
import script from "./OrderPaginatedTable.vue?vue&type=script&lang=js&"
export * from "./OrderPaginatedTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaginatedTable.vue?vue&type=style&index=0&id=4c5831d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5831d3",
  null
  
)

export default component.exports